import { Branding } from '../branding.interface';
import { GreenheartFooter } from './GreenheartFooter';
import { GreenheartHeader } from './GreenheartHeader';

const primaryMain = '#577b27';

export const greenheartBranding: Branding = {
  header: <GreenheartHeader />,
  footer: <GreenheartFooter />,
  fontFamily: 'Lato, sans-serif',
  paletteOptions: {
    primary: {
      main: primaryMain,
      light: '#74a535',
      dark: '#486620',
      contrastText: '#ffffff',
    },
    menuColor: primaryMain,
  },
};
